import React from "react";
import { Select } from "antd";
import { FormattedMessage } from "react-intl";

const { Option } = Select;

const ESelectType = props => {
  const { einvoiceType, setEinvoiceType } = props;

  const buildOptionItem = (labelDesci18n, optionVal) => {
    return (
      <Option
        style={{ textAlign: "left" }}
        label={
          <div>
            <b>
              {" "}
              <FormattedMessage id={"documents.preview.placeholder"} />{" "}
            </b>
            {<FormattedMessage id={labelDesci18n} />}
          </div>
        }
        value={optionVal}
      >
        <FormattedMessage id={labelDesci18n} />
      </Option>
    );
  };

  return (
    <Select
      value={einvoiceType}
      className={"selectStyle"}
      optionLabelProp="label"
      placeholder={<b>Modello grafico: </b>}
      onChange={value => {
        
        setEinvoiceType(value);
      }}
      getPopupContainer={trigger => trigger.parentNode}
    >
      {buildOptionItem("documents.preview.previewDoc", "ASSOSW")}
      {buildOptionItem("documents.preview.ae", "ADE")}
      {buildOptionItem("documents.preview.xml", "RAW")}
    </Select>
  );
};

export default ESelectType;
